<template>
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                        Asignación de campos de resultados
                    </v-col>
                     
            
                </v-row>

                <v-row class="col-md-12">
                    <v-col cols="12" md="6" sm="6" xs="12"  class="pb-0 pt-0">
                        <v-select
                            v-model="periodoMedicionId"
                            :items="periodos"
                            :loading="ddPeriodosLoading"
                            dense
                            outlined
                            label="Periodo de medición"
                            item-text="anioMedicion"
                            item-value="id"
                            return-object
                            :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            menu-props="auto"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pb-0 pt-0">
                        <v-select
                            v-model="departamentoId"
                            :items="deptos"
                            class="required"
                            dense
                            outlined
                            :loading="ddDeptosLoading"
                            label="Departamento"
                            item-text="nombreDepartamento"
                            item-value="id"
                            return-object
                            menu-props="auto"
                            @change="obtnenerMunicipiosPorDepto();"
                            :rules="[
                                selectRequired(
                                    'Departamento'
                                )
                            ]"
                            
                        >
                            <template slot='selection' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreDepartamento }}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreDepartamento }} <br/> 
                                        </v-col>
                                    </v-row>
                                </template>
                        </v-select>
                    </v-col>
                    <!--@change="obtenerAprobadoresRevisoresAsignados(); obtnenerMunicipiosPorDepto()"-->

                    <v-col cols="12" md="6" sm="6" xs="12" class="pb-0 pt-0">
                        <v-autocomplete
                            v-model="indiceId"
                            :items="indices"
                            class="required"
                            dense
                            outlined
                            :loading="ddIndicesLoading"
                            label="Seleccionar Índice"
                            item-text="nombreIndice"
                            item-value="id"
                            :rules="[
                                selectRequired(
                                    'Índice'
                                )
                            ]"
                            ></v-autocomplete>
                        </v-col>
                
                    <v-col cols="12" sm="3" md="3" xs="12" class="pb-0 pt-0">
                        <v-btn
                            color="primary"
                            class="mb-2 float-left bg-light-blue"
                            @click="obtnenerBoletasMuni();"
                        >
                            Buscar
                            <v-icon right>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col> 
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>

            
                        
            <v-card-text>

                
                <v-row>
                    <v-col cols="12" sm="4" md="4" xs="12">
                        <v-btn
                            color="primary"
                            class="mb-2 float-left bg-light-blue"
                            
                            @click="modalNueva"
                        >
                            Asignar Campos
                        </v-btn>
                    </v-col>

                    <v-col cols="12" md="8" sm="8" xs="12">
                        <v-text-field
                            outlined
                            append-icon="mdi-magnify"
                            autocomplete="off"
                            dense
                            v-model="tableFilter"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                        :headers="headers"
                        :items="boletasMuni"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="tableFilter"
                        :items-per-page="10"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                        dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <!--<td>{{ item.id }}</td>-->
                            <td>{{ item.anioMedicion }}</td>
                            <td>{{ item.codigoCampo }}</td>
                            <td>{{ item.nombreMunicipio }}, {{ item.nombreDepartamento }}</td>
                            
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosid === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <!--<td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>-->
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>




    <!-- Inicio:: Dialog para mostrar los datos de la puesto-->
    <v-dialog
        v-model="dialog"
        max-width="800px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>

                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosItem.periodoMedicionId"
                                :items="periodos"
                                :loading="ddPeriodosLoading"
                                dense
                                outlined
                                label="Periodo de medición"
                                item-text="anioMedicion"
                                item-value="id"
                                :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                                @change="obtnenerBoletas"
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="indiceSeleccionadoId"
                                :items="indices"
                                class="required"
                                dense
                                outlined
                                :loading="ddIndicesLoading"
                                label="Seleccionar Indice"
                                item-text="nombreIndice"
                                item-value="id"
                                return-object
                                :rules="[
                                    selectRequired(
                                        'Boleta'
                                    )
                                ]"
                                no-data-text="No se encontraron boletas"
                            >
                            <template slot='selection' slot-scope='{ item }'>
                                <v-row>
                                    <v-col cols="12">
                                        {{ item.codigo }} - {{ item.nombreIndice }}
                                    </v-col>
                                </v-row>
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                <v-row>
                                    <v-col cols="12">
                                        {{ item.codigo }} - {{ item.nombreIndice }} <br/> 
                                        <small class="text-overline>">{{ item.anioMedicion }}</small>
                                    </v-col>
                                </v-row>
                            </template>
                            </v-select>
                        </v-col>
                    </v-row>
                    <!--<v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            
                            <v-select
                                v-model="tipoSeleccionMunis"
                                :items="tiposSeleccion"
                                class="required"
                                dense
                                outlined
                                label="Tipo de selección"
                                item-text="nombre"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Tipo de selección'
                                    )
                                ]"
                                @change="obtnenerMunicipiosPorDepto()"
                            ></v-select>
                        </v-col>
                    </v-row>  v-if="tipoSeleccionMunis===2"-->
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            
                            <v-select
                                v-model="departamentoId"
                                :items="deptos"
                                class="required"
                                dense
                                outlined
                                :loading="ddDeptosLoading"
                                label="Departamento"
                                item-text="nombreDepartamento"
                                item-value="id"
                                return-object
                                :rules="[
                                    selectRequired(
                                        'Departamento'
                                    )
                                ]"
                                @change="obtnenerMunicipiosPorDepto()"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="municipiosSeleccionados"
                                :items="municipios"
                                class="required"
                                dense
                                outlined
                                :no-data-text="municipios != null ? 'Seleccione una municipalidad' : 'No se han encontrado municipios'"
                                :loading="ddMunicipiosLoading"
                                label="Seleccionar municipios"
                                item-text="nombreMunicipio"
                                item-value="id"
                                multiple
                                chips
                                return-object
                                :rules="[
                                    selectRequired(
                                        'Municipio'
                                    )
                                ]"
                                
                            >
                            <template v-slot:prepend-item>
                                <v-list-item
                                    ripple
                                    @click="toggle"
                                    >
                                    <v-list-item-action>
                                        <v-icon :color="municipiosSeleccionados.length > 0 ? 'indigo darken-4' : ''">
                                        {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                        Seleccionar todos
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-select>
                        </v-col>
                        
                    </v-row>

                    

                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                             <template>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                             </template>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la puesto-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import Vue from 'vue';
import moment from "moment";

import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_INDICES } from "@/core/services/store/catalogos/indice.module";
import { OBTENER_DEPARTAMENTOS} from "@/core/services/store/catalogos/departamento.module";
import { OBTENER_MUNICIPIOS_POR_DEPTO } from "@/core/services/store/catalogos/municipio.module";
import { OBTENER_BOLETAS } from "@/core/services/store/boletas/boleta.module";
import { OBTENER_BOLETA_MUNI, ACTUALIZAR_ASIGNACION } from "@/core/services/store/boletas/boletamuni.module";
import { ASIGNAR_CAMPOS_MUNI, OBTENER_CAMPOS_MUNI_POR_INDICE_PERIODO_DEPTO } from "@/core/services/store/camposresultados/camposmuniperiodo.module";
import { OBTENER_PERIODOS } from "@/core/services/store/catalogos/periodomedicion.module";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

moment.locale('es');
Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
    }
});

export default {
    name: "Asigboletas",
    components: {
        SnackAlert,
        DialogLoader
    },
    data() {
        return {
            tableLoading: false,
            tableFilter:'',
            validForm:false,
            itemName : "Campos",
            dialog: false,
            modalTitle: 'Asignar Campos',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            activePicker:null,
            tipoSeleccionMunis: 1,
            tiposSeleccion: [{id: 1, nombre: 'Todas las municipalidades'}, {id: 2, nombre: 'Seleccionar de forma parcial'}],
            departamentoId: 0,
            deptos: [],
            ddDeptosLoading: false,
            municipios: [],
            ddMunicipiosLoading: false,
            boletas: [],
            indiceSeleccionado: [{id: 0, nombre: ''}],
            indiceSeleccionadoId:0,
            boletasMuni: [],
            ddBoletasLoading: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Boleta',
            accion: 1,
            indices: [],
            indiceId: 0,
            ddIndicesLoading: false,
            ddPeriodosLoading: false,
            periodos: [],
            periodoMedicionId:0,
            switchItemEstado: true,
            datosItem: {
                id: 0,
                listaMunicipalidades:[],
                indiceId:0,
                estadosId: 1
            },
            municipiosSeleccionados:[],
            ...validations
        } 
    }, 
    methods: {
        toggle () {
        this.$nextTick(() => {
          if (this.likesAllMunicipios) {
            this.municipiosSeleccionados = []
          } else {
            this.municipiosSeleccionados = this.municipios.slice()
          }
        })
      },

        //!Definir la fecha máxima que se puede seleccionar en el datepicker
        maxDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear() + 1);
            return date.toISOString().substr(0, 10);
        },

        //!Definir la fecha minima que se puede seleccionar en el datepicker
        minDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear());
            return date.toISOString().substr(0, 10);
        },


        modalNueva(){
            this.accion =1;
            this.modalTitle='Asignar Campos';
            this.btnRegistroText='Asignar Campos';
            this.switchItemEstado=true;
            this.indiceSeleccionado= [{id: 0, nombre: ''}];
            this.dialog=true;
        },

        resetForm(){
           // this.$refs.form.reset();
           
             this.datosItem= {
                id: 0,
                listaMunicipalidades:[],
                indiceId:0,
                estadosId: 1
            };
            this.indiceSeleccionado= [{id: 0, nombre: ''}];
            this.switchItemEstado = true;
            //console.log(this.switchItemEstado)
        },


        //Obtener listado de índices
         async obtenerIndices(){
            this.indices=[];
            this.ddIndicesLoading=true;
            await this.$store
            .dispatch(OBTENER_INDICES, 1)
            .then(res => {
                if(res.status===200){
                    this.indices=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddIndicesLoading=false;
               
            }
            )
            .catch(() => {
                this.ddIndicesLoading=false;
                //console.warn(err)
            });


        },

        //!Obtener los periodos para la tabla
        obtnenerPeriodosMedicion(){
            this.ddPeriodosLoading = true;
            this.periodos=[];
            
            this.$store
                .dispatch(OBTENER_PERIODOS)
                .then(() => {
                    this.periodos = this.$store.state.periodomedicion.periodos;
                    this.ddPeriodosLoading =false;
                })
                .catch(() => {
                    this.ddPeriodosLoading = false;
                });

        },

        //!Obtener los departamentos para la tabla
        async obtnenerDepartamentos(){
            this.ddDeptosLoading = true;
            this.deptos=[];
            
            await this.$store
                .dispatch(OBTENER_DEPARTAMENTOS,1)
                .then(res => {
                    if(res.status==200){
                        this.deptos = this.$store.state.departamento.departamentos;
                    }
                    this.ddDeptosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddDeptosLoading = false;
                });

        },


        //!Obtener las etnias para la tabla
        async obtnenerMunicipiosPorDepto(){

            console.log(this.departamentoId.id)
            this.ddMunicipiosLoading = true;
            this.municipios=[];
            
            await this.$store
                .dispatch(OBTENER_MUNICIPIOS_POR_DEPTO, {departamentoId: this.departamentoId.id, estadoId: 1})
                .then(res => {
                    if(res.status==200){
                        this.municipios = this.$store.state.municipio.municipios;
                    }
                    this.ddMunicipiosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddMunicipiosLoading = false;
                });

        },

        //!Obtener las boletas para la llenar el dropdown
        obtnenerBoletas(){
            this.ddBoletasLoading = true;
            this.boletas=[];
            
            this.$store
                .dispatch(OBTENER_BOLETAS, {estadoId: 0, idPeriodo: this.datosItem.periodoMedicionId, idIndice: 0})
                .then(res => {
                    if(res.status===200){
                        this.boletas = this.$store.state.boleta.boletas;
                    }
                    this.ddBoletasLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddBoletasLoading = false;
                });

        },

        //!Obtener las boletas asignadas a las municipalidades
        async obtnenerBoletasMuni(){
           
            this.tableLoading = true;
            this.boletasMuni=[];
            
            await this.$store
                .dispatch(OBTENER_CAMPOS_MUNI_POR_INDICE_PERIODO_DEPTO, {periodoId: this.periodoMedicionId.id, indiceId: this.indiceId, deptoId: this.departamentoId.id })
                .then(res => {
                    if(res.status===200){
                    
                        this.boletasMuni = this.$store.state.camposmuniperiodo.camposResultados;
                    }
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(err => {
                    this.tableLoading = false;
                    console.log(err)
                });

        },
        

        //!Obtener los registros para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.boletas=[];
            
            this.$store
                .dispatch(OBTENER_BOLETAS, 0)
                .then(() => {
                    this.boletas = this.$store.state.boleta.boletas;
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosItem.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Asignación';
            this.btnRegistroText='Actualizar Asignación';

            this.$store
                .dispatch(OBTENER_BOLETA_MUNI, Id)
                .then(res => {
                   
                    if(res.status===200){
                        this.datosItem = this.$store.state.boleta.boleta;
                        this.indiceSeleccionado.id = this.datosItem.boletaId;
                        this.indiceSeleccionado.descripcion = this.datosItem.descripcion;

                        //console.log(this.datosItem)
                        this.datosItem.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.dialog = true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    //console.log(this.datosItem)
                   
                    this.dialogLoaderVisible = false;
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.log(error)
                });
        },

        registrarItem(){
            //console.log(this.accion)
            
            this.datosItem.indiceId = this.indiceSeleccionadoId.id;
            console.log(this.datosItem)
            //this.datosItem.municipiosId = this.municipiosSeleccionados[0];

             
            this.btnRegistroLoading=true;

            this.switchItemEstado ? this.datosItem.estadosId = 1 : this.datosItem.estadosId = 2;

            if(this.accion===1){

                this.datosItem.listaMunicipalidades = this.municipiosSeleccionados.map(function(item){
                    return {
                        municipiosId: item.id,
                    };
                });

                //console.log(this.datosItem)

                let tipo = 1;

                //console.log(this.tipoSeleccionMunis)
                if(this.tipoSeleccionMunis===2)
                    tipo=2;

                ///////////////////QUITAR AL HABILITAR LA ASIGNACION A TODAS LAS MUNIS
                tipo=2;

                this.datosItem.tipo=tipo;
                this.datosItem.id = 0;
                this.$store
                    .dispatch(ASIGNAR_CAMPOS_MUNI, this.datosItem)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerBoletasMuni();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            //this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_ASIGNACION, this.datosItem)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerBoletasMuni();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            //this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Resultados" },
            { title: "Asignar Campos" }
        ]);
    },

    created(){
        this.obtenerIndices();
        this.obtnenerBoletasMuni();
        this.obtnenerDepartamentos();
        this.obtnenerItems();
        //this.obtnenerBoletas();
        this.obtnenerPeriodosMedicion();
    },

    
    computed: {
         likesAllMunicipios () {
            return this.municipiosSeleccionados.length === this.municipios.length
        },
        likesSomeMunicipio () {
            return this.municipiosSeleccionados.length > 0 && !this.likesAllMunicipios
        },
        icon () {
            if (this.likesAllMunicipios) return 'mdi-close-box'
            if (this.likesSomeMunicipio) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        headers() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                {
                    text: "Año de Medición",
                    value: "anioMedicion"
                },
                {
                    text: "Código del campo",
                    value: "codigoCampo"
                },
                {
                    text: "Municipio",
                    value: "nombreMunicipio"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                }/*,
                {
                    text: "Acciones",
                    value: "Acciones"
                }*/
            ]
        }   
    },
    
}
</script>
<style lang="">
    
</style>